export type EquipmentIconCategory = "Security" | "Fire" | "Building" | "Network" | "General";

export interface EquipmentIconDefinition {
  key: string;
  label: string;
  category: EquipmentIconCategory;
  paths: string;
}

const iconColorToken = "__ICON_COLOR__";

const icons: EquipmentIconDefinition[] = [
  {
    key: "camera-fixed",
    label: "Fixed Camera",
    category: "Security",
    paths: '<rect x="4" y="8" width="8" height="8" fill="__ICON_COLOR__"/><path d="M12 10l8-3v10l-8-3z" fill="__ICON_COLOR__"/>'
  },
  {
    key: "camera-dome",
    label: "Dome Camera",
    category: "Security",
    paths: '<path d="M5 11a7 7 0 0 1 14 0v2H5z" fill="__ICON_COLOR__"/><path d="M4 13h16v2H4z" fill="__ICON_COLOR__"/><circle cx="12" cy="11" r="3" fill="#ffffff"/><circle cx="12" cy="11" r="1.5" fill="__ICON_COLOR__"/>'
  },
  {
    key: "nvr-dvr",
    label: "NVR/DVR",
    category: "Security",
    paths: '<rect x="4" y="4" width="16" height="4" rx="1" fill="__ICON_COLOR__"/><rect x="4" y="10" width="16" height="4" rx="1" fill="__ICON_COLOR__"/><rect x="4" y="16" width="16" height="4" rx="1" fill="__ICON_COLOR__"/><circle cx="7" cy="6" r="1" fill="#ffffff"/><circle cx="7" cy="12" r="1" fill="#ffffff"/><circle cx="7" cy="18" r="1" fill="#ffffff"/><path d="M11 6h6M11 12h6M11 18h6" stroke="#ffffff" stroke-width="1.5" stroke-linecap="round"/>'
  },
  {
    key: "access-reader",
    label: "Access Reader",
    category: "Security",
    paths: '<rect x="7" y="3" width="10" height="18" rx="2" fill="__ICON_COLOR__"/><rect x="9" y="6" width="6" height="4" rx="0.7" fill="#ffffff"/><path d="M10 13c1.3-1.3 2.7-1.3 4 0M9 16c2-2 4-2 6 0" stroke="#ffffff" stroke-width="1.4" fill="none" stroke-linecap="round"/><circle cx="12" cy="19" r="1" fill="#ffffff"/>'
  },
  {
    key: "door-contact",
    label: "Door Contact",
    category: "Security",
    paths: '<path d="M5 3h10v18H5z" fill="__ICON_COLOR__"/><path d="M15 5l4 2v12l-4 2z" fill="__ICON_COLOR__"/><circle cx="12.5" cy="12" r="1" fill="#ffffff"/><rect x="19" y="8" width="2" height="8" rx="1" fill="__ICON_COLOR__"/>'
  },
  {
    key: "motion-sensor",
    label: "Motion Sensor",
    category: "Security",
    paths: '<path d="M12 4a8 8 0 0 1 8 8h-4a4 4 0 0 0-4-4z" fill="__ICON_COLOR__"/><path d="M12 9a3 3 0 0 1 3 3h-3z" fill="__ICON_COLOR__"/><circle cx="9" cy="15" r="3" fill="__ICON_COLOR__"/><path d="M7 20h4" stroke="__ICON_COLOR__" stroke-width="2" stroke-linecap="round"/>'
  },
  {
    key: "glass-break",
    label: "Glass Break",
    category: "Security",
    paths: '<path d="M6 3h12v18H6z" fill="none" stroke="__ICON_COLOR__" stroke-width="2"/><path d="M13 3l-3 6 4 2-5 10M7 12l3-3M14 11l4 3" stroke="__ICON_COLOR__" stroke-width="1.7" fill="none" stroke-linecap="round" stroke-linejoin="round"/>'
  },
  {
    key: "intercom",
    label: "Intercom",
    category: "Security",
    paths: '<rect x="6" y="3" width="12" height="18" rx="2" fill="__ICON_COLOR__"/><circle cx="12" cy="7" r="1.4" fill="#ffffff"/><path d="M9 11h6M9 14h6M9 17h6" stroke="#ffffff" stroke-width="1.4" stroke-linecap="round"/><path d="M9 5h1M14 5h1" stroke="#ffffff" stroke-width="1.4" stroke-linecap="round"/>'
  },
  {
    key: "intrusion-panel",
    label: "Intrusion Panel",
    category: "Security",
    paths: '<rect x="4" y="5" width="16" height="14" rx="2" fill="__ICON_COLOR__"/><rect x="7" y="8" width="10" height="3" fill="#ffffff"/><circle cx="8" cy="15" r="1" fill="#ffffff"/><circle cx="12" cy="15" r="1" fill="#ffffff"/><circle cx="16" cy="15" r="1" fill="#ffffff"/>'
  },
  {
    key: "card-access-controller",
    label: "Card Access Controller",
    category: "Security",
    paths: '<rect x="4" y="4" width="16" height="16" rx="2" fill="__ICON_COLOR__"/><rect x="7" y="7" width="6" height="4" rx="0.7" fill="#ffffff"/><path d="M8 15h8M8 18h5" stroke="#ffffff" stroke-width="1.5" stroke-linecap="round"/><circle cx="16" cy="8" r="1" fill="#ffffff"/><circle cx="16" cy="11" r="1" fill="#ffffff"/><path d="M5 12H2M22 12h-3M12 2v3M12 19v3" stroke="__ICON_COLOR__" stroke-width="2" stroke-linecap="round"/>'
  },
  {
    key: "panic-button",
    label: "Panic Button",
    category: "Security",
    paths: '<circle cx="12" cy="12" r="9" fill="__ICON_COLOR__"/><circle cx="12" cy="12" r="5" fill="#ffffff"/><circle cx="12" cy="12" r="3" fill="__ICON_COLOR__"/>'
  },
  {
    key: "lock",
    label: "Lock",
    category: "Security",
    paths: '<rect x="5" y="10" width="14" height="10" rx="2" fill="__ICON_COLOR__"/><path d="M8 10V8a4 4 0 0 1 8 0v2" stroke="__ICON_COLOR__" stroke-width="2.4" fill="none" stroke-linecap="round"/><circle cx="12" cy="15" r="1.5" fill="#ffffff"/>'
  },
  {
    key: "gate-controller",
    label: "Gate Controller",
    category: "Security",
    paths: '<path d="M4 6h16v12H4z" fill="none" stroke="__ICON_COLOR__" stroke-width="2"/><path d="M8 6v12M12 6v12M16 6v12" stroke="__ICON_COLOR__" stroke-width="1.7"/><circle cx="19" cy="12" r="3" fill="__ICON_COLOR__"/><path d="M18 12h2" stroke="#ffffff" stroke-width="1.5" stroke-linecap="round"/>'
  },
  {
    key: "fire-alarm-panel",
    label: "Fire Alarm Panel",
    category: "Fire",
    paths: '<rect x="5" y="3" width="14" height="18" rx="2" fill="__ICON_COLOR__"/><path d="M12 6c3 3 4 5 4 8a4 4 0 0 1-8 0c0-2 1-4 4-8z" fill="#ffffff"/><path d="M12 10c1.4 1.6 2 2.7 2 4a2 2 0 0 1-4 0c0-1.2.6-2.4 2-4z" fill="__ICON_COLOR__"/>'
  },
  {
    key: "smoke-detector",
    label: "Smoke Detector",
    category: "Fire",
    paths: '<ellipse cx="12" cy="8" rx="8" ry="4" fill="__ICON_COLOR__"/><path d="M5 8c1 3 3.5 5 7 5s6-2 7-5" fill="none" stroke="__ICON_COLOR__" stroke-width="2"/><path d="M8 17c1-1 1-2 0-3M12 19c1-1.3 1-2.7 0-4M16 17c1-1 1-2 0-3" stroke="__ICON_COLOR__" stroke-width="1.6" fill="none" stroke-linecap="round"/>'
  },
  {
    key: "heat-detector",
    label: "Heat Detector",
    category: "Fire",
    paths: '<circle cx="12" cy="12" r="8" fill="none" stroke="__ICON_COLOR__" stroke-width="2"/><path d="M12 5v3M12 16v3M5 12h3M16 12h3" stroke="__ICON_COLOR__" stroke-width="2" stroke-linecap="round"/><path d="M12 9c2 2 3 3.6 3 5a3 3 0 0 1-6 0c0-1.4 1-3 3-5z" fill="__ICON_COLOR__"/>'
  },
  {
    key: "pull-station",
    label: "Pull Station",
    category: "Fire",
    paths: '<rect x="6" y="3" width="12" height="18" rx="1.5" fill="__ICON_COLOR__"/><rect x="8" y="6" width="8" height="4" fill="#ffffff"/><path d="M9 14h6l-3 4z" fill="#ffffff"/><path d="M10 12h4" stroke="#ffffff" stroke-width="1.4" stroke-linecap="round"/>'
  },
  {
    key: "horn-strobe",
    label: "Horn Strobe",
    category: "Fire",
    paths: '<rect x="4" y="6" width="8" height="12" rx="1" fill="__ICON_COLOR__"/><path d="M12 9l7-4v14l-7-4z" fill="__ICON_COLOR__"/><path d="M18 9l3-2M19 12h4M18 15l3 2" stroke="__ICON_COLOR__" stroke-width="1.7" stroke-linecap="round"/>'
  },
  {
    key: "sprinkler",
    label: "Sprinkler",
    category: "Fire",
    paths: '<path d="M8 4h8v4H8z" fill="__ICON_COLOR__"/><path d="M12 8v4" stroke="__ICON_COLOR__" stroke-width="2" stroke-linecap="round"/><path d="M6 12h12l-3 3H9z" fill="__ICON_COLOR__"/><circle cx="6" cy="19" r="1.2" fill="__ICON_COLOR__"/><circle cx="12" cy="20" r="1.2" fill="__ICON_COLOR__"/><circle cx="18" cy="19" r="1.2" fill="__ICON_COLOR__"/>'
  },
  {
    key: "fire-extinguisher",
    label: "Fire Extinguisher",
    category: "Fire",
    paths: '<path d="M10 7h4v3h1a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2H9a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2h1z" fill="__ICON_COLOR__"/><path d="M9 4h6M12 4v3M14 5l4 2" stroke="__ICON_COLOR__" stroke-width="1.8" fill="none" stroke-linecap="round"/><rect x="9" y="13" width="6" height="3" fill="#ffffff"/>'
  },
  {
    key: "fire-door",
    label: "Fire Door",
    category: "Fire",
    paths: '<path d="M6 3h11v18H6z" fill="__ICON_COLOR__"/><path d="M17 5l3 2v12l-3 2z" fill="__ICON_COLOR__"/><path d="M11 7c2 2 3 3.8 3 5.5a3 3 0 0 1-6 0c0-1.7 1-3.5 3-5.5z" fill="#ffffff"/><circle cx="15" cy="12" r="1" fill="#ffffff"/>'
  },
  {
    key: "gas-detector",
    label: "Gas Detector",
    category: "Fire",
    paths: '<rect x="6" y="5" width="12" height="14" rx="2" fill="__ICON_COLOR__"/><circle cx="12" cy="12" r="4" fill="#ffffff"/><path d="M10 12c1-2 3-2 4 0M10 15c1-2 3-2 4 0" stroke="__ICON_COLOR__" stroke-width="1.5" fill="none" stroke-linecap="round"/><path d="M9 3h6" stroke="__ICON_COLOR__" stroke-width="2" stroke-linecap="round"/>'
  },
  {
    key: "hvac-unit",
    label: "HVAC Unit",
    category: "Building",
    paths: '<rect x="4" y="5" width="16" height="14" rx="2" fill="__ICON_COLOR__"/><circle cx="12" cy="12" r="5" fill="#ffffff"/><path d="M12 7v10M7 12h10M8.5 8.5l7 7M15.5 8.5l-7 7" stroke="__ICON_COLOR__" stroke-width="1.4" stroke-linecap="round"/>'
  },
  {
    key: "thermostat",
    label: "Thermostat",
    category: "Building",
    paths: '<rect x="7" y="3" width="10" height="18" rx="5" fill="__ICON_COLOR__"/><circle cx="12" cy="16" r="3" fill="#ffffff"/><path d="M12 7v7" stroke="#ffffff" stroke-width="2" stroke-linecap="round"/><path d="M12 16v-4" stroke="__ICON_COLOR__" stroke-width="1.5" stroke-linecap="round"/>'
  },
  {
    key: "vav-box",
    label: "VAV Box",
    category: "Building",
    paths: '<rect x="4" y="7" width="16" height="10" rx="2" fill="__ICON_COLOR__"/><path d="M7 12h10" stroke="#ffffff" stroke-width="2" stroke-linecap="round"/><path d="M10 9l4 3-4 3z" fill="#ffffff"/>'
  },
  {
    key: "electrical-panel",
    label: "Electrical Panel",
    category: "Building",
    paths: '<rect x="6" y="3" width="12" height="18" rx="1.5" fill="__ICON_COLOR__"/><path d="M13 5l-4 8h3l-1 6 5-9h-3z" fill="#ffffff"/>'
  },
  {
    key: "generator",
    label: "Generator",
    category: "Building",
    paths: '<rect x="4" y="8" width="16" height="10" rx="2" fill="__ICON_COLOR__"/><circle cx="9" cy="13" r="3" fill="#ffffff"/><path d="M9 10v6M6 13h6" stroke="__ICON_COLOR__" stroke-width="1.4"/><path d="M15 9v-3h3" stroke="__ICON_COLOR__" stroke-width="2" fill="none" stroke-linecap="round"/>'
  },
  {
    key: "ups",
    label: "UPS",
    category: "Building",
    paths: '<rect x="7" y="3" width="10" height="18" rx="2" fill="__ICON_COLOR__"/><path d="M10 7h4M10 10h4" stroke="#ffffff" stroke-width="1.5" stroke-linecap="round"/><path d="M12 13l-2 4h2l-1 3 3-5h-2z" fill="#ffffff"/>'
  },
  {
    key: "lighting-control",
    label: "Lighting Control",
    category: "Building",
    paths: '<path d="M12 3a6 6 0 0 0-3 11v3h6v-3a6 6 0 0 0-3-11z" fill="__ICON_COLOR__"/><path d="M9 20h6" stroke="__ICON_COLOR__" stroke-width="2" stroke-linecap="round"/><path d="M9 17h6" stroke="#ffffff" stroke-width="1.4" stroke-linecap="round"/>'
  },
  {
    key: "water-valve",
    label: "Water Valve",
    category: "Building",
    paths: '<path d="M4 10h16v4H4z" fill="__ICON_COLOR__"/><path d="M10 8h4v8h-4z" fill="__ICON_COLOR__"/><path d="M7 5h10l-5 4z" fill="__ICON_COLOR__"/><circle cx="12" cy="18" r="3" fill="__ICON_COLOR__"/><path d="M10.5 18h3" stroke="#ffffff" stroke-width="1.4" stroke-linecap="round"/>'
  },
  {
    key: "pump",
    label: "Pump",
    category: "Building",
    paths: '<circle cx="10" cy="13" r="6" fill="__ICON_COLOR__"/><path d="M16 11h4v4h-4zM4 11H2v4h2z" fill="__ICON_COLOR__"/><path d="M8 10l5 3-5 3z" fill="#ffffff"/>'
  },
  {
    key: "elevator",
    label: "Elevator",
    category: "Building",
    paths: '<rect x="5" y="3" width="14" height="18" rx="1" fill="__ICON_COLOR__"/><path d="M12 6l-3 3h6zM12 18l3-3H9z" fill="#ffffff"/><path d="M12 10v4" stroke="#ffffff" stroke-width="1.5" stroke-linecap="round"/>'
  },
  {
    key: "network-switch",
    label: "Network Switch",
    category: "Network",
    paths: '<rect x="3" y="7" width="18" height="10" rx="1.5" fill="__ICON_COLOR__"/><rect x="5" y="10" width="2" height="2" fill="#ffffff"/><rect x="8" y="10" width="2" height="2" fill="#ffffff"/><rect x="11" y="10" width="2" height="2" fill="#ffffff"/><rect x="14" y="10" width="2" height="2" fill="#ffffff"/><rect x="17" y="10" width="2" height="2" fill="#ffffff"/><circle cx="6" cy="15" r="0.8" fill="#ffffff"/><circle cx="9" cy="15" r="0.8" fill="#ffffff"/>'
  },
  {
    key: "wireless-access-point",
    label: "Wireless Access Point",
    category: "Network",
    paths: '<rect x="6" y="12" width="12" height="7" rx="2" fill="__ICON_COLOR__"/><circle cx="12" cy="15.5" r="1.4" fill="#ffffff"/><path d="M8 9a6 6 0 0 1 8 0M5 6a10 10 0 0 1 14 0" stroke="__ICON_COLOR__" stroke-width="2" fill="none" stroke-linecap="round"/>'
  },
  {
    key: "firewall",
    label: "Firewall",
    category: "Network",
    paths: '<path d="M4 5h16v14H4z" fill="__ICON_COLOR__"/><path d="M4 10h16M4 15h16M9 5v5M15 5v5M7 10v5M13 10v5M18 10v5M10 15v4M16 15v4" stroke="#ffffff" stroke-width="1.4"/><path d="M12 8c2 2.1 3 3.8 3 5.4a3 3 0 0 1-6 0c0-1.6 1-3.3 3-5.4z" fill="#ffffff"/><path d="M12 11c0.9 1 1.3 1.8 1.3 2.5a1.3 1.3 0 0 1-2.6 0c0-0.7 0.4-1.5 1.3-2.5z" fill="__ICON_COLOR__"/>'
  },
  {
    key: "router-gateway",
    label: "Router/Gateway",
    category: "Network",
    paths: '<rect x="5" y="9" width="14" height="8" rx="2" fill="__ICON_COLOR__"/><path d="M8 13h8" stroke="#ffffff" stroke-width="1.6" stroke-linecap="round"/><path d="M13 10l3 3-3 3M11 10l-3 3 3 3" stroke="#ffffff" stroke-width="1.4" fill="none" stroke-linecap="round" stroke-linejoin="round"/><path d="M8 8l-3-3M16 8l3-3" stroke="__ICON_COLOR__" stroke-width="2" stroke-linecap="round"/>'
  },
  {
    key: "field-panel-enclosure",
    label: "Field Panel Enclosure",
    category: "Network",
    paths: '<rect x="5" y="3" width="14" height="18" rx="1.5" fill="__ICON_COLOR__"/><rect x="8" y="6" width="8" height="5" rx="0.7" fill="#ffffff"/><path d="M8 14h8M8 17h5" stroke="#ffffff" stroke-width="1.5" stroke-linecap="round"/><circle cx="16" cy="17" r="1" fill="#ffffff"/><path d="M19 8h2M19 12h2M19 16h2" stroke="__ICON_COLOR__" stroke-width="2" stroke-linecap="round"/>'
  },
  {
    key: "monitor-point",
    label: "Monitor Point",
    category: "General",
    paths: '<path d="M5 4h11v16H5z" fill="none" stroke="__ICON_COLOR__" stroke-width="2" stroke-linejoin="round"/><path d="M9 7l8-2v17l-8-3z" fill="__ICON_COLOR__"/><circle cx="11" cy="13" r="1" fill="#ffffff"/><path d="M3 20h18" stroke="__ICON_COLOR__" stroke-width="2" stroke-linecap="round"/>'
  },
  {
    key: "output-relay",
    label: "Output Relay",
    category: "General",
    paths: '<rect x="4" y="7" width="8" height="10" rx="1" fill="__ICON_COLOR__"/><path d="M12 12h8M17 9l3 3-3 3" stroke="__ICON_COLOR__" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"/><circle cx="8" cy="12" r="2" fill="#ffffff"/>'
  },
  {
    key: "ip-speaker",
    label: "IP Speaker",
    category: "Network",
    paths: '<path d="M4 9h5l6-4v14l-6-4H4z" fill="__ICON_COLOR__"/><path d="M18 8c2 2.5 2 5.5 0 8M20 5c4 4.5 4 9.5 0 14" stroke="__ICON_COLOR__" stroke-width="2" fill="none" stroke-linecap="round"/>'
  },
  {
    key: "radar",
    label: "Radar",
    category: "Security",
    paths: '<path d="M6 6a10 10 0 0 0 10 10l4-10z" fill="__ICON_COLOR__"/><path d="M9 17l4-4" stroke="__ICON_COLOR__" stroke-width="2" stroke-linecap="round"/><path d="M8 21h8" stroke="__ICON_COLOR__" stroke-width="2" stroke-linecap="round"/><path d="M12 15v6" stroke="__ICON_COLOR__" stroke-width="2" stroke-linecap="round"/><path d="M15 5a5 5 0 0 1 5 5M16 2a8 8 0 0 1 8 8" stroke="__ICON_COLOR__" stroke-width="1.5" fill="none" stroke-linecap="round"/>'
  },
  {
    key: "gunshot-detector",
    label: "Gunshot Detector",
    category: "Security",
    paths: '<path d="M3 18c0-4.8 2.5-8.3 6.4-9.6L7.8 6.6 9 5.4l2.4 2.3h4.1c1.2 0 2.1.6 2.6 1.5h3.1V8h1.4v1.2H23v2.2H18.4l-1.7 1.8h-4.2c-.4.8-1.1 1.4-2 1.8l-1.2 3z" fill="__ICON_COLOR__"/><path d="M14.2 9.2h6.4v1.1h-6.4z" fill="#ffffff"/><path d="M13.8 11.1h6.8v1.1h-6.8z" fill="#ffffff"/><path d="M9.3 8.9h4.4" stroke="#ffffff" stroke-width="1.2" stroke-linecap="round"/><path d="M9.1 10.7h4.4" stroke="#ffffff" stroke-width="1.2" stroke-linecap="round"/><path d="M8.9 12.5h3.8" stroke="#ffffff" stroke-width="1.2" stroke-linecap="round"/><circle cx="10.6" cy="14.2" r="1.6" fill="#ffffff"/><path d="M11.7 13.2c.9.6 1.1 1.8.6 2.7-.5.8-1.5 1.1-2.4.8" stroke="__ICON_COLOR__" stroke-width="1.2" fill="none" stroke-linecap="round"/>'
  },
  {
    key: "other",
    label: "Other",
    category: "General",
    paths: '<path d="M12 2l7 7-7 13L5 9z" fill="__ICON_COLOR__"/><circle cx="12" cy="9" r="2" fill="#ffffff"/>'
  }
];

const standardIconKeyByName: { [name: string]: string } = {
  "camera": "camera-fixed",
  "gunshot detector": "gunshot-detector",
  "intercom": "intercom",
  "ip speaker": "ip-speaker",
  "monitor point": "monitor-point",
  "node": "card-access-controller",
  "nvr/dvr": "nvr-dvr",
  "other": "other",
  "output": "output-relay",
  "radar": "radar",
  "reader": "access-reader",
  "network switch": "network-switch",
  "switch": "network-switch",
  "wireless access point": "wireless-access-point",
  "wap": "wireless-access-point",
  "firewall": "firewall",
  "router": "router-gateway",
  "gateway": "router-gateway",
  "router/gateway": "router-gateway",
  "field panel enclosure": "field-panel-enclosure"
};

export const equipmentIconLibrary = icons;

export function getEquipmentIcon(key: string | null | undefined): EquipmentIconDefinition {
  return icons.find(icon => icon.key === key) || icons[icons.length - 1];
}

export function getStandardEquipmentIconKey(name: string | null | undefined): string | null {
  const normalizedName = (name || "").trim().toLowerCase();
  return standardIconKeyByName[normalizedName] || null;
}

export function guessEquipmentIconKey(name: string | null | undefined): string {
  const normalizedName = (name || "").toLowerCase();
  const matches: Array<[RegExp, string]> = [
    [/dome/, "camera-dome"],
    [/camera|cctv/, "camera-fixed"],
    [/nvr|dvr|recorder/, "nvr-dvr"],
    [/reader|card|badge/, "access-reader"],
    [/door.*contact|contact/, "door-contact"],
    [/motion|pir/, "motion-sensor"],
    [/glass/, "glass-break"],
    [/intercom/, "intercom"],
    [/field.*panel|panel.*enclosure|enclosure/, "field-panel-enclosure"],
    [/panel|intrusion|alarm panel/, "intrusion-panel"],
    [/panic|duress/, "panic-button"],
    [/lock/, "lock"],
    [/gate/, "gate-controller"],
    [/fire.*panel/, "fire-alarm-panel"],
    [/smoke/, "smoke-detector"],
    [/heat/, "heat-detector"],
    [/pull/, "pull-station"],
    [/horn|strobe|speaker strobe/, "horn-strobe"],
    [/sprinkler/, "sprinkler"],
    [/extinguisher/, "fire-extinguisher"],
    [/gas|co\b|carbon/, "gas-detector"],
    [/hvac|ahu|rtu/, "hvac-unit"],
    [/thermostat/, "thermostat"],
    [/vav/, "vav-box"],
    [/electrical|breaker/, "electrical-panel"],
    [/generator/, "generator"],
    [/ups|battery/, "ups"],
    [/light/, "lighting-control"],
    [/valve|water/, "water-valve"],
    [/pump/, "pump"],
    [/elevator|lift/, "elevator"],
    [/wireless access point|\bwap\b|access point/, "wireless-access-point"],
    [/firewall/, "firewall"],
    [/router|gateway/, "router-gateway"],
    [/network switch|switch|network/, "network-switch"],
    [/monitor/, "monitor-point"],
    [/output|relay/, "output-relay"],
    [/speaker|pa|audio/, "ip-speaker"],
    [/radar/, "radar"],
    [/gunshot|shot/, "gunshot-detector"]
  ];
  const match = matches.find(candidate => candidate[0].test(normalizedName));
  return match === undefined ? "other" : match[1];
}

export function renderEquipmentIconSvg(key: string | null | undefined, color = "#ff1f1f"): string {
  const icon = getEquipmentIcon(key);
  const namedColors = ["black", "blue", "brown", "gray", "green", "grey", "orange", "purple", "red", "white", "yellow"];
  const normalizedColor = color.trim().toLowerCase();
  const safeColor = /^#[0-9a-f]{3}([0-9a-f]{3})?$/i.test(color) || namedColors.indexOf(normalizedColor) >= 0 ? color : "#ff1f1f";
  return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" aria-hidden="true">${icon.paths.replace(/__ICON_COLOR__/g, safeColor)}</svg>`;
}

export function renderStandardEquipmentTypeIconSvg(name: string | null | undefined, color = "#ff1f1f"): string {
  return renderEquipmentIconSvg(
    getStandardEquipmentIconKey(name) || guessEquipmentIconKey(name),
    color
  );
}

export function makeSvgDataUrl(svg: string): string {
  return "data:image/svg+xml;utf-8," + encodeURIComponent(svg);
}
